import { defineNuxtRouteMiddleware } from "#imports";
import { isSamePath, withoutHost } from "ufo";

export default defineNuxtRouteMiddleware((to) => {
  // // 404 exclusion
  // const isErrorPage = !(to.matched.length > 0);
  // if (isErrorPage) {
  //   return;
  // }

  const store = useAuthStore();
  const config = useRuntimeConfig().public.auth;
  const auth = useAuth();

  const toPathIsLogin = isSamePath(to.path, config.paths.login);

  if (store.loggedIn && toPathIsLogin) {
    setTimeout(auth.navigateToHome, 1);
    return;
  }

  if (store.loggedIn || to.meta.auth === false) {
    return;
  }

  if (!toPathIsLogin) {
    const nextDest = withoutHost(window.location.href);
    if (!isSamePath(nextDest, config.paths.login)) {
      auth.setDestination(nextDest);
    }
    return navigateTo(config.paths.login);
  }
});
